import type {ValueOf} from '~/types/value-of'

export const searchFilterType = {
  ALL: 'ALL',
  BLOCK: 'BLOCK',
  TRANSACTION: 'TRANSACTION',
  ADDRESS: 'ADDRESS',
  TOKEN: 'TOKEN',
} as const
export type searchFilterType = ValueOf<typeof searchFilterType>;